import { render, staticRenderFns } from "./descriptionSavedTaskCard.vue?vue&type=template&id=2ce5440b&"
import script from "./descriptionSavedTaskCard.vue?vue&type=script&lang=js&"
export * from "./descriptionSavedTaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports